import Linkify from 'linkify-react';
import { Typography, Link } from '@mui/material';
import { IntermediateRepresentation } from 'linkifyjs';
import { useRemoteI18n } from '../../../../../remote_i18n/useRemoteI18n';

const LinkRenderer = (
  props: IntermediateRepresentation & { color?: string },
) => {
  const { attributes, content } = props;
  return (
    <Link
      {...attributes}
      sx={{ color: props.color }}
      target='_blank'
      rel='noopener noreferrer'
    >
      {content}
    </Link>
  );
};

export const TextMessage = (props: {
  content: string;
  contentKey: string | undefined;
  contentParams: string[] | undefined;
  color: string;
  hrefColor?: string;
}) => {
  const remoteI18n = useRemoteI18n();
  const { content, contentKey, contentParams } = props;
  const i18nContent = contentKey
    ? remoteI18n(contentKey, contentParams ?? [])
    : content;
  return (
    <Typography
      sx={{
        fontSize: 16,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        color: props.color,
      }}
    >
      <Linkify
        options={{
          render: (linkifyProps) =>
            LinkRenderer({ ...linkifyProps, color: props.hrefColor }),
        }}
      >
        {i18nContent}
      </Linkify>
    </Typography>
  );
};
